import { Check, Info, Warning, WarningCircle } from "phosphor-react";
import { toast } from "react-toastify";

export default class Notifications {
  static update = (id, options) => toast.update(id, options);

  // null = dismiss all
  static dismiss = (id = null) => toast.dismiss(id);

  static success = (content, options = {}) =>
    toast(content, {
      bodyClassName: "text-lg font-[Roboto] text-green-600",
      progressClassName: "bg-green-600",
      type: toast.TYPE.SUCCESS,
      icon: (
        <span className="text-2xl text-green-600">
          <Check weight="bold" />
        </span>
      ),
      ...options,
    });

  static warning = (content, options = {}) =>
    toast(content, {
      bodyClassName: "text-lg font-[Roboto] text-yellow-600",
      progressClassName: "bg-yellow-600",
      type: toast.TYPE.WARNING,
      icon: (
        <span className="text-2xl text-yellow-600">
          <Warning weight="bold" />
        </span>
      ),
      ...options,
    });

  static error = (content, options = {}) =>
    toast(content, {
      bodyClassName: "text-lg font-[Roboto] text-red-600",
      progressClassName: "bg-red-600",
      type: toast.TYPE.ERROR,
      icon: (
        <span className="text-2xl text-red-600">
          <WarningCircle weight="bold" />
        </span>
      ),
      ...options,
    });

  static info = (content, options = {}) =>
    toast(content, {
      bodyClassName: "text-lg font-[Roboto] text-blue-600",
      progressClassName: "bg-blue-600",
      type: toast.TYPE.INFO,
      icon: (
        <span className="text-2xl text-blue-600">
          <Info weight="bold" />
        </span>
      ),
      ...options,
    });

  static show = (content, options = {}) => toast(content, options);
}
